import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./index.css";

import AppLayout from "./pages/Layout";

import Login from "./pages/Login";

// pasajeros
import PassengersTable from "./components/PassengerTable";
import PassengerForm from "./components/PassengerForm";

// transfers y payments
import Debts from "./pages/Debts";
import DebtDetail from "./pages/DebtDetail";
import PaymentHistory from "./pages/PaymentsHistory";
import TransferHistory from "./pages/TransferHistory";
import Caja from "./pages/Caja";

// otros
import Groups from "./pages/Groups";
import Excursions from "./pages/Excursions";
import Users from "./pages/Users";
import ExcursionBusesTable from "./components/ExcursionBusesTable";
import ExcursionBusDetail from "./pages/ExcursionBusDetail";
import SellerCommission from "./pages/SellerCommission";
import EmailImportHistory from "./pages/EmailImportHistory";

// Analytics
import BusesAnalytics from "./pages/BusesAnalytics";
import ExpensesAnalytics from "./pages/ExpensesAnalytics";

// Calendar
import Calendar from "./pages/Calendar";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter basename={process.env.PUBLIC_URL}>
    <Routes>
      <Route path="login" element={<Login />} />
      <Route path="/" element={<Navigate to="/excursiones" />} />
      <Route path="/" element={<AppLayout />}>
        {/* pasajeros */}
        <Route path="pasajeros" element={<PassengersTable />} />
        <Route path="pasajeros/crear" element={<PassengerForm />} />
        <Route path="pasajeros/:passengerId" element={<PassengerForm />} />
        <Route path="historial-emails" element={<EmailImportHistory />} />
        {/* transfers y payments*/}
        <Route path="transfers/debts" element={<Debts />} />
        <Route path="transfers/debts/sellers" element={<Debts defaultType="USER_SELLER" />} />
        <Route path="transfers/debts/guides" element={<Debts defaultType="USER_GUIDE" />} />
        <Route path="transfers/debts/coordinators" element={<Debts defaultType="USER_COORDINATOR" />} />
        <Route path="transfers/debts/companies" element={<Debts defaultType="COMPANY" />} />
                <Route path="transfers/history" element={<TransferHistory />} />
        <Route path="caja" element={<Caja />} />
        <Route path="transfers/debt/:userId" element={<DebtDetail />} />
        <Route path="transfers/:transferId/detail" element={<DebtDetail />} />
        <Route path="payments/history" element={<PaymentHistory />} />
        {/* otros */}
        <Route path="calendario" element={<Calendar />} />
        <Route path="grupos" element={<Groups />} />

        <Route path="seller-commission" element={<SellerCommission />} />

        <Route path="excursiones" element={<Excursions />} />
        <Route
          path="excursiones/:excursionId/buses"
          element={<ExcursionBusesTable />}
        />
        <Route
          path="excursiones/:excursionId/buses/:busId"
          element={<ExcursionBusDetail />}
        />

        <Route path="users" element={<Users />} />

        {/* Analytics */}
        <Route path="analytics/buses" element={<BusesAnalytics />} />
        <Route path="analytics/expenses" element={<ExpensesAnalytics />} />
      </Route>
    </Routes>
  </BrowserRouter>
);
